<section class="single-project-wrap-layout">
    <div class="container">
        <div class="single-project-box-layout1">
            <div class="single-project-info">
                <div class="item-content">
                    <h1 class="heading-layout1">Bombas de diafragma</h1>
                </div>
                <div class="row justify-content-between">
                    <div class="col-lg-8">
                        <div class="item-content">
                            <h3 class="item-title">WILDEN </h3>
                            <p> Es el inventor de las bombas neumáticas y es el fabricante más grande a 
                                nivel mundial de estas. Las Bombas neumáticas emplean el aire comprimido 
                                para mover y hacer funcionar mecanismos, se utilizan en casi cualquier 
                                industria desde la minera hasta la alimenticia, cuenta con diferentes modelos tales como:
                            </p>
                            <ul class="list-item">
                                <li><i class="fas fa-check"></i>Pro-Flo®, Pro-FloV™, Pro-FloX™, Accu-Flo™</li>
                                <li><i class="fas fa-check"></i>Construcciones plásticas y metálicas</li>
                                <li><i class="fas fa-check"></i>Cierre con tornillos o abrazaderas</li>
                                <li><i class="fas fa-check"></i>Aplicaciones sanitarias Sani-flo™</li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-lg-3 offset-md-1">
                        <div class="single-project-slider">
                            <div class="rc-carousel nav-control-layout2 owl-carousel owl-loaded owl-drag" data-loop="true" data-items="10" 
                            data-margin="10" data-autoplay="false" data-autoplay-timeout="3000" data-smart-speed="1000" data-dots="false" 
                            data-nav="true" data-nav-speed="false" data-r-x-small="1" data-r-x-small-nav="true" data-r-x-small-dots="false" 
                            data-r-x-medium="1" data-r-x-medium-nav="true" data-r-x-medium-dots="false" data-r-small="1" data-r-small-nav="true"
                            data-r-small-dots="false" data-r-medium="1" data-r-medium-nav="true" data-r-medium-dots="false" data-r-large="1" 
                            data-r-large-nav="true" data-r-large-dots="false" data-r-extra-large="1" data-r-extra-large-nav="true" 
                            data-r-extra-large-dots="false">
                                <div class="slide-item">
                                    <img src="./assets/img/productos/bombas_diafragma/wilden/logo_wilden.png" alt="logo_wilden | Fengari">
                                </div>
                                <div class="slide-item">
                                    <img src="./assets/img/productos/bombas_diafragma/wilden/diafragmas_wilden.png" alt="diafragmas_wilden | Fengari">
                                </div>
                                <div class="slide-item">
                                    <img src="./assets/img/productos/bombas_diafragma/wilden/xps1520_atex_aluminum_npt_wilden.jpg" alt="xps1520_atex_aluminum_npt_wilden | Fengari">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 offset-md-9">
                        <div class="about-box-layout4">
                            <div class="about-box-content">
                                <a href="./productos" class="ghost-btn-lg primary-border text-Primary mg-t-15"><i class="fas fa-angle-left"></i> Regresar</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>